<template>
    <div class="container" :class="{scrAcive: isStop} " @scroll="handleScroll1">
      <div class="sidebar">
        <ul>
          <li
            v-for="(item, index) in dataList"
            :key="item.id"
            :class="{ active: currentIndex === index }"
            @click="scrollToSection(index)"
          >
          <!-- /static/image/hot1.png -->
          <img v-if="item.id === 0" :src="getImageUrl(currentIndex === index  ? '/static/image/hot2.png' : '/static/image/hot1.png')" :alt="item.name" /> 
          <img v-else :src="getImageUrl(currentIndex === index  ? item.pic_active : item.pic)" :alt="item.name" /> 
          <span>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="content"  ref="content" @scroll="handleScroll">

        <div
          v-for="(item, index) in dataList"
          :key="item.id"
          :ref="'section' + index"
          class="section"
        >
      
        
          <!-- <h2>{{ item.name }}</h2> -->
          <ul>
            <template v-if="item.id === 0">
              <div class="gemini-hot-games-area-simplified">
            <div v-for="game in item.data"
               :key="game.id"
                   class="gemini-hot-item-simplified"
                   @click="handleGameClick(game)">
                <div class="gemini-hot-item-content-simplified">
                  <!-- 游戏图片容器 -->
                  <div class="gemini-hot-image-wrapper-simplified">
                    <img class="gemini-hot-image-simplified" :src="game.mobile_img" :alt="game.name">
                    <!-- 新游戏标记 (保留，如果需要可以再移除) -->
                    <img v-if="game.is_new === 1"
                         src="/static/image/new-tag.png"
                         alt="新"
                         class="gemini-tag-simplified gemini-tag-new-simplified">
                  </div>
                  <!-- 游戏名称 -->
                  <div class="gemini-hot-name-simplified">{{ game.name }}</div>
                </div>
              </div>
              </div>
              </template>
              <template v-else>  
            <li v-for="(data, i) in item.data" :key="i">
              <img :src="data.image" alt="" class="img" >
            </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
      props:{
          dataList:{
              default:[],
              type:Array
          },
          isStop:{
            default:false,
            type:Boolean
          }
      },
    data() {
      return {
         
        currentIndex: 0
      }
    },
    watch:{
      isStop(newVal) {
        console.log(newVal);
        if(newVal){

        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.content.addEventListener('scroll', this.handleScroll)
      })
    },
    beforeDestroy() {
      this.$refs.content.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
      getImageUrl(relativePath) {
          if (!relativePath || typeof relativePath !== 'string') return '';
          if (relativePath.startsWith('http') || relativePath.startsWith('data:')) { return relativePath; }
          if (relativePath.startsWith('/static/')) { return relativePath; }
          return '/storage/' + relativePath.replace(/^\/+/, ''); 
      },
      scrollToSection(index) {
        console.log(index);
        
        const section = this.$refs['section' + index][0]
        console.log(section);
        
        if (section) {
          this.$refs.content.scrollTop = section.offsetTop - 10
          console.log(this.$refs.content.scrollTop);
          
        }
      },
      handleScroll1(){
        const scrollTop = this.$refs.content.scrollTop
        console.log(scrollTop,8);
      },
      handleScroll() {
        const scrollTop = this.$refs.content.scrollTop
        console.log(scrollTop);
        
        let currentIndex = 0
        let minDistance = Infinity
  
        this.dataList.forEach((_, index) => {
          const section = this.$refs['section' + index][0]
          if (section) {
            const distance = Math.abs(section.offsetTop - scrollTop - 10)
            if (distance < minDistance) {
              minDistance = distance
              currentIndex = index
            }
          }
        })
  
        this.currentIndex = currentIndex
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .container {
    display: flex;
    height: 100vh;
    overflow: hidden;
    padding: 0 20px;
  }
  
  .sidebar {
    width:82px;
    overflow-y: auto;
  
  }
  
  .sidebar ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar li {
  //   padding: 12px 16px;
    cursor: pointer;
  //   border-left: 3px solid transparent;
    transition: all 0.3s;
    text-align: center;
        border-radius: 4px;
        padding: 4px 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        // min-height: 60px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // background: #f5f0e294;
        background: url('/static/image/btn_zc1_2.avif') no-repeat center center;
        background-size: 100%;
        width: 78px;
        height: 36px;
        // justify-content: center;
        color: #666;
        img {
          width: 30px;
          height: 25px;
          display: block;
          // margin: 0 auto;
        }
        span {
          font-size: 10px;
          display: block;
          margin-top: 3px;
          // color: #666;
        }
  }
  
  .sidebar li.active {
    background-color: #e0e0e0;
    border-left-color: #409eff;
    color: #409eff;
  }
  
  .content {
    flex: 1;
    // overflow-y: auto;
    padding: 20px 0 20px 10px;
  }
  .scrAcive{
    position: sticky;
    left: 0;
    top: 0;
    width: 100%;
  }
  .section {
    margin-bottom: 40px;
  }
  
  .section h2 {
    margin-top: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  
  .section ul {
    list-style: none;
    padding: 0;
  }
  
  .section li {
    padding: 8px 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .section li .img{
    width: 100%;
    border-radius: 8px;
  }
  
  .section li:last-child {
    border-bottom: none;
  }
  .gemini-hot-games-area-simplified {
  display: flex;
  flex-wrap: wrap;
  background: transparent;
  padding: 5px;
  box-sizing: border-box;
}

.gemini-hot-item-simplified {
  width: 33.33%;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.gemini-hot-item-content-simplified {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  margin: 0 auto;
}

.gemini-hot-image-wrapper-simplified {
  position: relative; /* 用于定位新标签 */
  width: 100%;
  padding-top: 100%; /* 关键：强制容器高度等于宽度，形成正方形 */
  border-radius: 12px; /* 保留圆角 */
  overflow: hidden;
}

.gemini-hot-image-simplified {
  position: absolute; /* 让图片填充绝对定位的容器 */
  top: 0;
  left: 0;
  width: 100%; /* 图片宽度占满容器 */
  height: 100%;     /* 图片高度也占满容器 */
  display: block;
  object-fit: cover; /* 关键：图片覆盖整个容器，保持比例，多余部分裁剪 */
  border-radius: 12px; /* 给图片本身也加上圆角 */
}

.gemini-tag-simplified {
  position: absolute;
  z-index: 2;
}

/* 新游戏标记 */
.gemini-tag-new-simplified {
  top: 3px;
  right: 3px;
  width: 20px;
  height: 20px;
}

.gemini-hot-name-simplified {
  font-size: 12px;
  color: #555;
  margin-top: 6px;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 移除其他 gemini- 开头的旧样式 */

/* 热门标记 */
.hot-tag {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  z-index: 2;
}

.hot-tag img {
  width: 100%;
  height: 100%;
}
  </style>  


// WEBPACK FOOTER //
// src/components/mode/list.vue